// src/pages/Privacy.tsx

import * as React from "react";

import {
  Link,
} from "react-router-dom";

import {
  PublicFooter,
} from "../components/PublicFooter";

import {
  Seo,
} from "../components/Seo";

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export default function Privacy():
React.JSX.Element {
  return (
    <main className="public-site">
      <Seo
        title="Privacy | Estatly"
        description="Read Estatly's privacy policy."
        canonicalPath="/privacy"
      />

      <section className="public-legal">
        <div className="public-container public-legal-inner">
          <Link
            to="/"
            className="public-wordmark"
            aria-label="Estatly home"
          >
            Estatly
          </Link>

          <div className="public-legal-content">
            <p className="public-section-label">
              Privacy
            </p>

            <h1>
              Privacy policy
            </h1>

            <p>
              Estatly respects your privacy and is committed to handling personal information responsibly.
            </p>

            <p>
              This page is a placeholder for the final Estatly privacy policy and should be replaced with the approved legal text before production launch.
            </p>
          </div>
        </div>
      </section>

      <PublicFooter />
    </main>
  );
}